import React from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";

import emailService from "../services/email.service";
import Loader from "./Loader";

class AlterarSenha extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            nome: "",
            cpf: "",
            email: "",
            status: 0,
            novaSenha: "",
            confSenha: "",
        };
    }

    async componentDidMount() {
        const {
            history,
            auth: { authenticated },
        } = this.props;

        if (!authenticated) {
            history.push("/");
        } else {
            try {
                this.setState({ isLoading: true });
                const { nome, cpf, email } = await emailService.enderecoAtualAsync();

                this.setState({ nome, cpf, email, isLoading: false });
            } catch (e) {
                history.push("/");
            }
        }
    }

    emailBlur = async (e) => {
        const {
            state: { email },
            props: { history },
        } = this;
        if (email) {
            try {
                this.setState({ isLoading: true });
                const { status } = await emailService.verificarAsync(email);
                this.setState({ status, isLoading: false });
            } catch (e) {
                history.push("/");
            }
        }
    };

    validarCPF(inputCPF) {
        let soma = 0;
        let resto;

        if (inputCPF == '00000000000') return false;

        for (let i = 1; i <= 9; i++) soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (11 - i);
        resto = (soma * 10) % 11;

        if ((resto == 10) || (resto == 11)) resto = 0;
        if (resto != parseInt(inputCPF.substring(9, 10))) return false;

        soma = 0;
        for (let i = 1; i <= 10; i++) soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (12 - i);
        resto = (soma * 10) % 11;

        if ((resto == 10) || (resto == 11)) resto = 0;
        if (resto != parseInt(inputCPF.substring(10, 11))) return false;
        return true;
    }

    handleOk = async () => {
        let msg = "";
        const { nome, cpf, email, status, novaSenha, confSenha } = this.state;

        if (cpf) {
            const regexCpf = /^\d{11}$/;
            if (regexCpf.test(cpf) && this.validarCPF(cpf)) {
                if (email) {
                    const regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
                    if (regexEmail.test(email)) {
                        if (status !== 2) {
                            if (novaSenha === confSenha || status === 1) {
                                try {
                                    this.setState({ isLoading: true });
                                    var credentials = { cpf, email, novaSenha, confSenha };
                                    const { success, message } = await emailService.alterarSenhaAsync(credentials);

                                    if (success) {
                                        alert("Senha alterada com sucesso!\r\n\r\nFavor efetuar login novamente.");
                                        this.handleCancelar();
                                    } else {
                                        msg = message ? message : "Dados inválidos, tente novamente!";

                                        this.setState({
                                            status: 0,
                                            novaSenha: "",
                                            confSenha: "",
                                        });
                                    }
                                } catch (e) {
                                    console.log(e);
                                    msg = "Erro ao validar os dados informados, tente novamente!";

                                    this.setState({
                                        status: 0,
                                        novaSenha: "",
                                        confSenha: "",
                                    });
                                } finally {
                                    this.setState({ isLoading: false });
                                }
                            } else {
                                msg = "Repita a nova senha corretamente!";
                            }
                        } else {
                            msg = "Email já registrado para outro usuário";
                        }
                    } else {
                        msg = "Email informado é inválido";
                    }
                } else {
                    msg = "Email deve ser informado";
                }
            } else {
                msg = "CPF informado é inválido";
            }
        } else {
            msg = "CPF deve ser informado";
        }

        if (msg) {
            alert(msg);
        }
    };

    handleCancelar = () => {
        const { history } = this.props;
        history.goBack();
    };

    render() {
        const { nome, cpf, email, status, novaSenha, confSenha } = this.state;

        return (
            <Segment className={this.props.className}>
                <Loader isLoading={this.state.isLoading} />
                <Header as="h2">
                    <p>ALTERAR EMAIL/SENHA</p>
                </Header>

                <Form size="large">
                    <Form.Input
                        fluid
                        icon="user"
                        readOnly={true}
                        iconPosition="left"
                        placeholder="Nome"
                        value={nome}
                        type="text"
                    />
                    <Form.Input
                        fluid
                        icon="vcard"
                        iconPosition="left"
                        placeholder="CPF"
                        value={cpf}
                        type="number"
                        onChange={(e) => this.setState({ cpf: e.target.value })}
                    />
                    <Form.Input
                        fluid
                        icon="at"
                        iconPosition="left"
                        placeholder="Email"
                        value={email}
                        type="text"
                        onChange={(e) => this.setState({ email: e.target.value.toLowerCase() })}
                        onBlur={this.emailBlur}
                    />
                    <Form.Input
                        fluid
                        icon={status === 1 ? "unlock" : "lock"}
                        iconPosition="left"
                        placeholder={status === 1 ? "Senha atual" : "Senha nova"}
                        value={novaSenha}
                        type="password"
                        disabled={status === 2}
                        onChange={(e) => this.setState({ novaSenha: e.target.value })}
                    />
                    {status !== 1 ? (
                        <Form.Input
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="Repetir senha nova"
                            value={confSenha}
                            type="password"
                            disabled={status === 2}
                            onChange={(e) => this.setState({ confSenha: e.target.value })}
                        />
                    ) : null}

                    <Grid>
                        <Grid.Column width={16} floated="right" textAlign="right">
                            <Button size="large" onClick={this.handleOk} disabled={status === 2}>
                                <div style={{ width: "70px" }}>Ok</div>
                            </Button>
                            <Button size="large" onClick={this.handleCancelar}>
                                <div style={{ width: "70px" }}>Cancelar</div>
                            </Button>
                        </Grid.Column>
                    </Grid>
                </Form>
            </Segment>
        );
    }
}

const mapStateToProps = ({ auth }) => ({ auth });
export default connect(mapStateToProps, null)(AlterarSenha);
